// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__kwb8b","content":"Modal_content__21v-S"};